// Librerias
import React from 'react'
let PropTypes = React.PropTypes
//Componentes
import Modal from 'react-bootstrap/lib/Modal.js'
import { ModalTrigger, ModalComentario } from './Modal.jsx'
// Styles
import cssModal from './Modal.css'
import * as css from './SelectCaptadores.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)
let glyphs = [
    '',    // 0 - nunca ocurre
    '',    // 1 - Deshabilitada
    'glyphicon glyphicon-plus',      // 2 - Pendiente a enviar solicitud
    'glyphicon glyphicon-time',      // 3 - Solicitud enviada
    'glyphicon glyphicon-ok',        // 4 - Solicitud aprobada
    'glyphicon glyphicon-remove'     // 5 - Solicitud rechazada
]
export class ButtonSolicitud extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            optionsVisible: false,
            estado: '',
            comentario: ''
        }
        this.toggleMenu = ()=> {
            if (this.state.optionsVisible)
                this._hideMenu()
            else
                this._showMenu()
        }
        this._showMenu = ()=> {
            this.setState({optionsVisible: true})
        }
        this._hideMenu = ()=> {
            this.setState({optionsVisible: false})
        }
        this.aceptar = (comentario)=> {
            this.setState({
                estado: 3,
                optionsVisible: false,
                comentario: comentario
            }, ()=>{
                this.props.onGuardar(this.props.idNomina, {estadoSolicitud: this.state.estado, comentarioDotacion: this.state.comentario})
            })
        }
        this.cancelar = ()=> {
            this.setState({
                estado: 1,
                optionsVisible: false
            }, ()=>{
                this.props.onGuardar(this.props.idNomina, {estadoSolicitud: this.state.estado, comentarioDotacion: ''})
            })
        }
    }
    render(){
        return this.props.visible?
            <div>
                <div className={cx('captador-div')}>
                        <div className={cx('solicitud')}
                             onClick={this.toggleMenu}
                             ref={ref=>this.nodeTrigger = ref}
                        >
                            <span className={glyphs[this.props.idEstadoDotacion]}></span>
                        </div>
                </div>
                <div ref={ref=>this.node=ref}>
                    <ul className={cx('options', {'options-hidden': this.state.optionsVisible==false})}>
                        <Aceptar 
                            aceptar={this.aceptar}
                        />
                        <li className={cx('option-blankspace')} >&nbsp;</li>
                        <li className={cx('glyphicon glyphicon-remove','options-btn-solicitud')} onClick={this.cancelar}>
                            Cancelar
                        </li>
                    </ul>
                </div>
            </div>
            :
            null
    }
}
ButtonSolicitud.propTypes = {
    onGuardar: PropTypes.func.isRequired,
    idNomina: PropTypes.number,
    idEstadoDotacion: PropTypes.number
}
const Aceptar = ({aceptar})=>
    <ModalTrigger>
    {(isVisible, showModal, hideModal)=>
        <li className={cx('glyphicon glyphicon-ok','options-btn-solicitud')} onClick={showModal}>
            Aceptar
            {isVisible && (
                <ModalComentario
                    hideModal={hideModal}
                    aceptar={aceptar}
                />
            )}
        </li>
    }
    </ModalTrigger>


// WEBPACK FOOTER //
// ./frontEnd/components/shared/ButtonSolicitud.jsx